import {useTranslation} from 'react-i18next';
import {cn} from '@chekin/guestapp-ui-kit';

type Props = {
  onLearnMore?: () => void;
  className?: string;
};

export function FormHeader({onLearnMore, className}: Props) {
  const {t} = useTranslation();

  return (
    <div
      className={cn('flex w-full flex-col items-start gap-[8px] max-w-[702px]', className)}
    >
      <h2 className="text-[26px] font-semibold leading-[30px] tracking-[-0.52px] font-[var(--title-font-family)] text-[var(--form-title-color,#222222)] m-0">
        {t('add_details')}
      </h2>
      <p className="text-[16px] font-normal leading-[22px] text-[var(--form-subtitle-color,#6c6c6c)] m-0">
        {t('add_details_description')}{' '}
        {onLearnMore && (
          <button
            type="button"
            onClick={onLearnMore}
            className="inline underline text-[var(--form-title-color,#222222)] font-medium bg-transparent border-0 p-0 cursor-pointer"
          >
            {t('learn_more')}
          </button>
        )}
      </p>
    </div>
  );
}
